import { useCallback, useEffect, useState } from 'react';
import {
  configuracoesApi,
  type ChaveConfiguracao,
} from '@/features/configuracoes/api/configuracoesApi';

export function useConfiguracao(chave: ChaveConfiguracao) {
  const [valor, setValor] = useState<string | null>(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState<string | null>(null);

  const recarregar = useCallback(async () => {
    setCarregando(true);
    setErro(null);
    try {
      const r = await configuracoesApi.obter(chave);
      setValor(r.valor);
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Falha ao carregar configuração.');
    } finally {
      setCarregando(false);
    }
  }, [chave]);

  useEffect(() => {
    void recarregar();
  }, [recarregar]);

  return { valor, carregando, erro, recarregar, setValor };
}
